import React, { useCallback, useMemo, useState } from 'react';
import { TextContainer, CharacterLimit } from './TextFieldLimited';
import { TextField } from 'DesignSystem';
import { IProps as TextFieldProps } from 'DesignSystem/Inputs/TextField/TextField';

interface IProps extends TextFieldProps {
  'data-testId'?: string;
  charLimit?: number;
  lightBordered?: boolean;
  value?: string | null;
}

// Todo: combine with TextFieldLimited.js
const LimitedTextField: React.FC<IProps> = ({
  'data-testId': dataCy,
  charLimit = 50,
  lightBordered = false,
  ...props
}: IProps) => {
  const [focused, setFocused] = useState(false);

  // if text already exists and it is longer than the limit, then the limit is not applied
  const applyCharLimit = useMemo(() => {
    return (props.value || '').length <= charLimit;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [charLimit]);

  const handleFocus = useCallback(() => {
    setFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setFocused(false);
  }, []);

  return (
    <TextContainer lightBordered={lightBordered}>
      <TextField
        {...props}
        inputProps={{
          ...(props.inputProps ? props.inputProps : {}),
          'data-testId': dataCy,
          maxLength: applyCharLimit ? charLimit : null,
          onBlur: handleBlur,
          onFocus: handleFocus,
        }}
      />
      {applyCharLimit && (
        <CharacterLimit visible={focused}>{`${
          (props.value || '').length
        }/${charLimit}`}</CharacterLimit>
      )}
    </TextContainer>
  );
};

export default LimitedTextField;
